import React from "react";

export default function Kontakt() {
  return (
    <section className="bg-dark text-white min-h-screen p-6 md:p-12">
      <h2 className="text-3xl font-bold text-gold mb-6 text-center">Kontakt</h2>

      <div className="max-w-xl mx-auto text-center space-y-4">
        <p className="text-lg">
          Du möchtest mit mir in Kontakt treten oder hast Fragen zu meinen Projekten?
        </p>

        <p>
           E-Mail: <a href="mailto: behluel_67@hotmail.de" className="text-gold underline hover:text-white">kontakt@bkelez-data.com</a>
        </p>

        <p>
           LinkedIn: <a href="https://www.linkedin.com/in/behluelkelez/" target="_blank" rel="noopener noreferrer" className="text-gold underline hover:text-white">linkedin.com/in/behluelkelez</a>
        </p>

        <p>
           GitHub: <a href="https://github.com/BKelez" target="_blank" rel="noopener noreferrer" className="text-gold underline hover:text-white">github.com/BKelez</a>
        </p>

        <p>
           Xing: <a href="https://www.xing.com/profile/Behluel_Kelez/web_profiles" target="_blank" rel="noopener noreferrer" className="text-gold underline hover:text-white">xing.com/profile/Behluel_Kelez/web_profiles</a>
        </p>
      </div>
    </section>
  );
}
